export const socialsData = {
    github: 'https://github.com/rakesh6451',
    facebook: 'https://www.facebook.com/people/rakesh.chowdary.31392410',
    linkedIn: 'https://www.linkedin.com/in/rakesh-ganesula-372870192/',
    instagram: 'https://www.instagram.com/rakesh_ganesula/?hl=en',
    codepen: 'https://codepen.io/',
    leetcode: 'https://leetcode.com/rakesh7643/',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    hackerrank:'https://www.hackerrank.com/rakeshganeshula',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    codechef: 'https://www.codechef.com/users/rakesh6451',
    twitter:'https://twitter.com/GaneshulaRakesh',
    youtube:'https://www.youtube.com/channel/UCyJVtHEEXenAKSbYRxXNjrA',
}